<template>
  <div id="my-invest">
    <v-container>
      <a-card title="银行帐户影本">
        <img :src="imageUrl" height="150" v-if="imageUrl" />
        <v-text-field label="Select Image" @click='pickFile' v-model='imageName' prepend-icon='attach_file'></v-text-field>
        <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked">
      </a-card>

      <a-card title="个人身分证件影本">
        <img :src="imageUrl2" height="150" v-if="imageUrl2" />
        <v-text-field label="Select Image" @click='pickFile2' v-model='imageName2' prepend-icon='attach_file'></v-text-field>
        <input type="file" style="display: none" ref="image2" accept="image/*" @change="onFilePicked2">
      </a-card>

      <v-btn color="warning" @click="uploadImg()">上传资料</v-btn>

    </v-container>
  </div>
</template>

<script>
export default {
  inject: ['reload'],
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      imageName: '',
      imageUrl: '',
      imageFile: '',

      imageName2: '',
      imageUrl2: '',
      imageFile2: ''
    }
  },
  methods: {
    pickFile() {
      this.$refs.image.click()
    },
    pickFile2() {
      this.$refs.image2.click()
    },

    onFilePicked(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
          this.imageFile = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.imageName = ''
        this.imageFile = ''
        this.imageUrl = ''
      }
    },

    onFilePicked2(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName2 = files[0].name
        if (this.imageName2.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl2 = fr.result
          this.imageFile2 = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.imageName2 = ''
        this.imageFile2 = ''
        this.imageUrl2 = ''
      }
    },

    uploadImg() {
      const file = this.imageFile
      const file2 = this.imageFile2

      if (!file || !file2) {
        this.$message.error('请上传两张才完成认证')
        return
      }

      if (!file.type.match(/image.*/) || !file2.type.match(/image.*/)) {
        return
      }
      const formData = new FormData()
      formData.append('file', file)
      formData.append('file2', file2)
      formData.append('user_id', this.id)

      this.$store.dispatch('uploadImg', formData).then((res) => {
        this.$message.success('上传成功')
        this.$router.go(0)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
